// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6dac99c9","839":"2fa8fea5","895":"b4a4a18a","922":"cf2df7b2","966":"75cb21b0"}[chunkId] + ".chunk.js";
};